import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "./ArticlesSection.css";

const token = localStorage.getItem("token");

const ArticlesSection = () => {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const [articles, setArticles] = useState([]);

  const handleScroll = (dir) => {
    scrollRef.current.scrollBy({
      left: dir === "right" ? 300 : -300,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const res = await axios.get("/article", {
          headers: { Authorization: `Bearer ${token}` },
        });
        // On filtre les articles non supprimés si besoin (selon ton backend)
        const visible = res.data.filter((a) => !a.deletedAt);
        setArticles(visible);
      } catch (error) {
        console.error("Erreur lors du chargement des articles:", error);
      }
    };

    fetchArticles();
  }, []);

  return (
    <section className="articles-section">
      <h2 className="title">Nos derniers articles</h2>
      <p className="subtitle">
        Découvrez les actualités, conseils, et études de notre équipe.
      </p>

      <div className="articles-wrapper">
        {articles.length > 0 && (
          <button className="arrow-btn left" onClick={() => handleScroll("left")}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
        )}

        <div className="articles-container" ref={scrollRef}>
          {articles.length > 0 ? (
            articles.map((article) => (
              <div className="article-card" key={article.id}>
                {article.imageUrl && (
                  <img
                    src={`/${article.imageUrl}`}
                    alt={article.title}
                    className="article-img"
                  />
                )}
                <div className="article-info">
                  <h3>{article.title}</h3>
                  <p className="ptag">
                    <b>Sujet :</b> {article.subject}
                  </p>
                  <p className="ptag">
                    <b>Date :</b> {new Date(article.postingDate).toLocaleDateString()}
                  </p>
                  <p className="ptag">
                    <b>Tags :</b> {Array.isArray(article.tags) ? article.tags.join(", ") : ""}
                  </p>
                  <div className="paragraph-extract">
                    {Array.isArray(article.paragraphs) && article.paragraphs.length > 0 && (
                      <span>
                        {article.paragraphs[0].text.slice(0, 100)}...
                      </span>
                    )}
                  </div>
                  <button
                    className="link-btn"
                    onClick={() => navigate(`/admin/articles/${article.id}`)}
                  >
                    Lire l'article
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p>Aucun article trouvé.</p>
          )}
        </div>

        {articles.length > 0 && (
          <button className="arrow-btn right" onClick={() => handleScroll("right")}>
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        )}
      </div>

      <div className="articles-btn">
        <button onClick={() => navigate("/admin/articles")}>
          Gérer les articles
        </button>
      </div>
    </section>
  );
};

export default ArticlesSection;
